<div class="rounded-2.5xl w-full text-center">
  <div class="px-12 md:px-24 py-6 md:py-12 border-gray-300 border-b">
    <h1 class="text-xl md:text-3xl" [innerHTML]="title"></h1>
    <h2 class="text-sm md:text-base" [innerHTML]="subtitle"></h2>
  </div>
  <div class="px-12 md:px-24 py-6 md:py-12">
    <h4 class="font-normal">{{ content }}</h4>
    <label for="ga-seats" class="label">Quantity of seats: </label>
    <input
      type="number"
      min="0"
      [(ngModel)]="gaNumSeats"
      oninput="value = !!value && Math.abs(value) >= 0 ? Math.abs(value) : null"
      class="inline-block ml-4 w-32 font-bold text-center input"
      name="ga-seats"
      id="ga-seats" />
    <div class="flex justify-center mt-6 md:mt-12">
      @if (closeBtnName) {
        <button
          (click)="close()"
          class="disabled:opacity-30 mr-3 md:mr-6 disabled:hover:transform-none hover:scale-95 transition-transform btn-main-reverse">
          {{ closeBtnName }}
        </button>
      }
      @if (acceptBtnName) {
        <button
          class="disabled:opacity-30 disabled:hover:transform-none hover:scale-95 transition-transform btn-main"
          (click)="accept()">
          {{ acceptBtnName }}
        </button>
      }
    </div>
  </div>
</div>
